import { useContext, useMemo } from "react";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import GlobalStyles from "@mui/material/GlobalStyles";
import { jaJP, enUS, ptBR } from "@mui/material/locale";

import { ColorModeContext } from "@shared/context";
import { themeDark, themeLight, themeGlobal, stylesLight, stylesGlobal, stylesDark } from "@shared/styles";

export const MuiProvider = ({ children }) => {
	const { colorMode } = useContext(ColorModeContext);

	const stylesObj = useMemo(() => {
		return { dark: { ...stylesGlobal, ...stylesDark }, light: { ...stylesGlobal, ...stylesLight } };
	}, []);

	const globalTheme = createTheme(themeGlobal);
	const styles = colorMode === "light" ? stylesObj.light : stylesObj.dark;
	const theme = createTheme(globalTheme, colorMode === "light" ? themeLight : themeDark, enUS);

	return (
		<>
			<GlobalStyles styles={styles} />
			<ThemeProvider theme={theme}>{children}</ThemeProvider>
		</>
	);
};
